module.exports = __webpack_public_path__ + "static/img/card-info-h5.4e5be16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-info-h5.png
// module id = QiwR
// module chunks = 34